import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, catchError, retry, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ObjectController } from '../object-controller/objectcontroller.service';
import { LocalStorageService } from '../localstorage-service/localstorage-service';
import { StandardUIService } from '../standardui-service/standardui-service';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'private, max-age=1200'
  })
};

export const httpGetOptions = {
  headers: new HttpHeaders({

  })
};
export const httpJsonPostOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',

  })
};

export interface ArrayItem {
  addaddressdetailscheckbox:any;
  refno: any;
  contactdata: any;
  casetypedata: any;
  locationdata: any;
  alertservicedata: any;
  associateddata: any;
  scriptdata: any;
  isassociated: any;
  mapdata: any;
  scriptpayloaddata: any
  dynamiccomponentdata: any
  serviceTypeInfo: any,
  dataInfo: any
  customcreatedata: any,
  modifyscript: any,
  submitandcontinue: any
  filteredvalue: any,
  searchterms: any,
  modifiedfromanonymouscontact: any,
  selecteddepartment:any,
  loadmappingresponse:any,
  addaddressdetails:any,
  genesysdata:any,
  addressdetailform:any,
  giserror:any
}

export const httpFormPostOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'

  })
};
@Injectable({
  providedIn: 'root',
})


export class AgentscriptService_updated {


  defaultview='gridView'
  toggleview='listView'
  // Allarraydata: ArrayItem[] = [];
  // associatedArray: { referrenceid: any, associatedelement: any[], alertelement:any[] }[] = [];
  subGroupItem: BehaviorSubject<any> = new BehaviorSubject<any>({});
  // isGisVerified: boolean;
  Associated = false;
  subGroupItemQuery$: Observable<any> = this.subGroupItem.asObservable();
  constructor(private standardservice:StandardUIService, private httpClient: HttpClient, private objcontroller: ObjectController,private localStorageService:LocalStorageService) { }
  httpHeaders = new HttpHeaders();
  searchAddress: any;
  backendUrl = environment.apiURL;
  casetypename: any
  divisionname: any
  departmentname: any
  tableau_site_id:any
  tableau_auth_token:any
  setSubGroupItem(item: string): void {
    this.subGroupItem.next(item);
  }
  onSaveMakeSr(payload: any): Observable<any> {
    return this.httpClient.post(this.backendUrl, payload, httpJsonPostOptions);
  }
  private eventData = new Subject<any>();
  eventData$ = this.eventData.asObservable();

  sendEvent(event: any) {
    this.eventData.next(event);
    console.log(event, 'eventaa')
  }
  addressEmitter: EventEmitter<any> = new EventEmitter<any>();

  addresstobesearched: any
  locationcoordinates: any
  emitAddress(address: any) {
    // console.log("in service emitter" + address)
    this.addressEmitter.emit(address);
  }

  mapsuggestions(suggestion: any) {
setTimeout(() => {
  $('#spinner').addClass('hideload');
},2);

    // return this.httpClient.get<any>("https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&text="+suggestion+"&location=%7B%22x%22%3A-9477697.545503102%2C%22y%22%3A5024044.098940275%2C%22spatialReference%22%3A%7B%22wkid%22%3A102100%7D%7D&distance=50000")
    //return this.httpClient.get<any>("https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?f=json&text=" + suggestion + "%20Fort%20Wayne&location=%7B%22x%22%3A-9477652.390546516%2C%22y%22%3A5024207.888201883%2C%22spatialReference%22%3A%7B%22wkid%22%3A102100%7D%7D&distance=50000")
     return  this.httpClient.get<any>(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?location=%7B%22spatialReference%22%3A%7B%22wkid%22%3A102100%2C%22latestWkid%22%3A3857%7D%2C%22x%22%3A-9479098.299180098%2C%22y%22%3A5024575.701031058%7D&maxSuggestions=6&outSR=%7B%22spatialReference%22%3A%7B%22wkid%22%3A102100%2C%22latestWkid%22%3A3857%7D%7D&searchExtent=%7B%22spatialReference%22%3A%7B%22wkid%22%3A102100%2C%22latestWkid%22%3A3857%7D%2C%22xmin%22%3A-9525000%2C%22ymin%22%3A5006000%2C%22xmax%22%3A-9433000%2C%22ymax%22%3A5043000%7D&countryCode=USA&text=${encodeURIComponent(suggestion)}&f=json`);
     //return this.httpClient.get<any>(`https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?location=%7B%22spatialReference%22%3A%7B%22latestWkid%22%3A3857%2C%22wkid%22%3A102100%7D%2C%22x%22%3A-9479098.299180098%2C%22y%22%3A5024575.701031058%7D&maxSuggestions=6&outSR=%7B%22latestWkid%22%3A3857%2C%22wkid%22%3A102100%7D&searchExtent=%7B%22spatialReference%22%3A%7B%22latestWkid%22%3A3857%2C%22wkid%22%3A102100%7D%2C%22xmin%22%3A-9513342.08785187%2C%22ymin%22%3A5010817.035939721%2C%22xmax%22%3A-9444854.510508325%2C%22ymax%22%3A5038334.366122395%7D&text=${encodeURIComponent(suggestion)}&f=json`);
     
  }

  fetchaddressdetails(address: any, addresstype: any, casetypeid: any) {
    console.log(casetypeid, "casetypeid")
    const formData = {
      "Address": address,
      "DeptId": "",
      "CasetypeId": casetypeid,
      "Color": "",
      "AddressType": addresstype
    }
    return this.httpClient.post(environment.apiURL + 'showLocationFromAddress', formData)

  }

  streetlocator(streetaddresss: any) {
    return this.httpClient.get<any>("https://gis.acimap.us/311/rest/services/locator/StreetFinder/GeocodeServer/findAddressCandidates?Street=&Single+Line+Input=" + streetaddresss + "&outFields=*&maxLocations=&outSR=4326&searchExtent=&f=pjson")
  }

  addresslocator(queryStringAddress: any) {
    return this.httpClient.get<any>("https://gis1.acimap.us/imapweb/rest/services/Locators/imapaddressfinder/GeocodeServer/findAddressCandidates?Street=&Single+Line+Input=" + queryStringAddress + "&outFields=*&maxLocations=&outSR=4326&searchExtent=&f=pjson")
  }


  submitandcontinue: boolean

  recenttickets:any=[]
  categorizedItems: { title: string, items: any[] }[] = [];
  agentrecentaccess() {
    this.httpClient.get(environment.apiURL + 'getAgentRecentAccess').subscribe((data:any)=>
    {
      this.recenttickets=data
      console.log(data)
        const currentTime = new Date();
        const today: any[] = [];
        const yesterday: any[] = [];
        const older: any[] = [];
        console.log(this.recenttickets)
        this.recenttickets.forEach(item => {
          //console.log(item)
          const itemTime = new Date(item.createdtime);

          // Calculate time difference in milliseconds
          const timeDifference = currentTime.getTime() - itemTime.getTime();

          // Convert milliseconds to hours
          const timeDifferenceHours = timeDifference / (1000 * 60 * 60);

          if (timeDifferenceHours <= 24) {
            today.push(item);
          } else if (timeDifferenceHours > 24 && timeDifferenceHours < 48) {
            yesterday.push(item);
          } else if (timeDifferenceHours > 48 ){
            older.push(item);
          }
        });

        this.categorizedItems = [
          { title: 'Today', items: today },
          { title: 'Yesterday', items: yesterday },
          { title: 'Older', items: older }
        ];

        // console.log(today)
        // console.log(yesterday)
        // console.log(older)
    })
  }

  refreshanswers()
  {
    this.httpClient.get(environment.apiURL + 'RefreshAllAnswers').subscribe((data:any)=>
    {
      console.log(data)
    })
  }
  refreshcitizenportalanswers()
  {
    this.httpClient.get(environment.backendurl + 'RefreshAllAnswers').subscribe((data:any)=>
    {
      console.log(data)
    })
  }

  addtorecentservices(casetypedata:any) {
    const payload={
      "department":casetypedata.department.id,
      "casetype":casetypedata.casetypeid,
      "casesubtype":casetypedata.casesubtypeid!=null?casetypedata.casesubtypeid:null
    }
    return this.httpClient.post(this.backendUrl+'saveAccessedServiceRequest', payload, httpJsonPostOptions);

  }
  public AlldataArray: ArrayItem[] = [];
  // refno;  contactdata;  locationdata;  alertservicedata;  nearbyincidentdata;  scriptdata;
  updateOrInsertArray(referenceId: any, propertyName: any, associatedItem: any): void {

    console.log(associatedItem)
    let item = this.AlldataArray.find(item => item.refno == referenceId);
    if (!item) {
      console.log("item not found so pushing")
      const newItem: ArrayItem = {
        addaddressdetailscheckbox:[],
        refno: referenceId,
        casetypedata: [],
        contactdata: [],
        locationdata: [],
        alertservicedata: [],
        associateddata: [],
        scriptdata: [],
        isassociated: [],
        mapdata: [],
        scriptpayloaddata: [],
        dynamiccomponentdata: [],
        serviceTypeInfo: [],
        dataInfo: [],
        customcreatedata: [],
        modifyscript: [],
        submitandcontinue: [],
        filteredvalue: [],
        searchterms: [],
        modifiedfromanonymouscontact: [0],
        selecteddepartment:[0],
        loadmappingresponse:[],
        addaddressdetails:[0],
        genesysdata:[0],
        addressdetailform:[],
        giserror:[]
      };
      newItem[propertyName] = [associatedItem];
      console.log(newItem)
      this.AlldataArray.push(newItem);
      console.log(this.AlldataArray)
    } else {
      if (!item[propertyName]) {
        item[propertyName] = [associatedItem];
      } else {
        item[propertyName][0] = associatedItem;
      }
      console.log(this.AlldataArray);
      // }
    }
    this.standardservice.SavetolocalStorage('tabdata',this.AlldataArray)

  }

  getAssociatedButton(refno: any, associatedItem: any) {
    // console.log(refno,associatedItem)
    const item = this.AlldataArray.find(item => item.refno == refno);
    if (item && item.isassociated.includes(true)) {
      // console.log(item)
      if (item.associateddata[0]?.referenceNumber == associatedItem.referenceNumber) {
        return false;
      }
    }
    return true;
  }

  getIfAssociated(refno: any) {
    console.log(this.AlldataArray)
    const item = this.AlldataArray.find(item => item.refno == refno);
    if (item) {
      console.log(item)
      return item.isassociated
    }
    return [false]

    // console.log(item.isassociated)
    // console.log(item[0])
    // console.log(item[0][0])
    // console.log(item[0].isassociated)
    // return item.isassociated
  }

  private handleError(errorObj: HttpErrorResponse | any) {
    const _self = this;
    let errorMessage: string;
    let body: any;
    if (errorObj instanceof HttpErrorResponse) {
      if (errorObj.ok === false && errorObj.status === 0) {
        errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
      } else {
        body = errorObj.error || '';
        errorMessage = body.message ? body.message : body.error.message;
      }
    }
    return throwError(errorMessage);
  }

  getPageById(id: number) {
    //console.log(objname);
    return this.httpClient.get(this.backendUrl + 'getPage/' + id, {
      headers: this.httpHeaders
    }).pipe(retry(2), catchError(this.handleError));
  }

  filterEmptyValues(obj: any): any {
    const filteredObject: any = {};
    Object.keys(obj).forEach(key => {
      if (key !== "next_collection_day" && obj[key] != "" && obj[key] != null && obj[key] != undefined && obj[key] != 'null') {
        filteredObject[key] = obj[key];
      }
    });
    return filteredObject;
  }

  Incidentpayload: any
  contactpayload: any
  customcreatepayload: any
  generatecustomcreatePayload(referenceId: any): Observable<any> {
    console.log(referenceId)
    console.log(this.AlldataArray)
    let selectedItem = this.AlldataArray.find(item => item.refno == referenceId);
    if (!selectedItem) {
      return new Observable(observer => {
        observer.error('Selected item not found'); // Emit an error
        observer.complete(); // Complete the observable
      });
    }
    else {
      console.log(this.AlldataArray)
      console.log(selectedItem)
      console.log(referenceId)
      var casetypedatainfo=this.fetchData(referenceId, 'casetypedata').serviceDetails
      console.log(casetypedatainfo)
      console.log(this.AlldataArray)
      // let contact=this.fetchData(referenceId,'contactdata')
      let Incident = this.fetchData(referenceId, 'scriptpayloaddata')
      // console.log(contact)
      console.log(Incident.serviceDetails.formScriptData)

      this.Incidentpayload=this.filterEmptyValues(Incident.serviceDetails.formScriptData)

      var subject = Incident.serviceDetails.caseTypeData.division?.name + "-" + Incident.serviceDetails.caseTypeData.department?.name + (Incident.serviceDetails.caseTypeData.casesubtypename ? "-" + Incident.serviceDetails.caseTypeData.casetypename + "-" + Incident.serviceDetails.caseTypeData.casesubtypename : "-" + Incident.serviceDetails.caseTypeData.content)

      var parentid = null
      if (this.getIfAssociated(referenceId).includes(true)) {
        console.log(this.fetchData(referenceId, 'associateddata'))
        parentid = this.fetchData(referenceId, 'associateddata').id
        console.log(parentid)
        // self.changeEventPayload['Incident.parentid'] = this.agentscriptservice_updated.fetchData(this.tab_title, 'associateddata').id
      }
      var scriptpayloaddata=this.fetchData(referenceId,'scriptpayloaddata')

      const payload = [
        {
          "entityName": "Incident",
          "payLoad": {
            "parentid": parentid,
            "contactid": +Incident.serviceDetails.caseTypeData.contactDtls?.contactid,
            // "casesubtype": Incident.serviceDetails.caseTypeData.casesubtypeid ? Incident.serviceDetails.caseTypeData.casesubtypeid : '',
            // "casetype": Incident.serviceDetails.caseTypeData.casetypeid,
            // "department": Incident.serviceDetails.caseTypeData.department?.id,
            // "division": Incident.serviceDetails.caseTypeData.division?.id,
            // "incidentqueue": Incident.serviceDetails.caseTypeData?.qid,
            "casetype": 296,
            "department": +casetypedatainfo.department.id,
            "division": +casetypedatainfo.division.id,
            "incidentqueue": 21,
            "subject": casetypedatainfo.division.name+"-"+casetypedatainfo.department.name+"-"+casetypedatainfo.content,
            ...this.Incidentpayload,
            "incidentstatus": 2,
            "servicerequestsource": 1356,
            "incidenttypeworkspace":196,
            "createdid":JSON.parse(this.localStorageService.get('currentUser'))?.id
          }
        },
        {
          "entityName": "Contact",
          "payLoad":{
              "id":+scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.contactid,
              "contacttextarea": scriptpayloaddata.serviceDetails.formScriptData?.contacttextarea,
              "addressid": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.mailingadd!='null'?scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.mailingadd:'',
              "lastname": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.lastname,
              "alternateph": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.phonenumber2,
              "emailalt1": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.emailalt1,
              "firstname": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.firstname,
              "phonenumber": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.phonenumber1,
              "email": scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.emailaddress,
              "title": "1",
              "street":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.street,
              "city":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.city,
              "postalcode":scriptpayloaddata.serviceDetails.caseTypeData.contactDtls?.postalcode,
              "countryid":1,
              "providenceid":19
          }
        }
        // ,
        // {
        //   "entityName": "Contact",
        //   "payLoad": {
        //     // "id":Incident.serviceDetails.caseTypeData.contactDtls?.contactid,
        //     "contacttextarea": Incident.serviceDetails.formScriptData?.contacttextarea,
        //     "addressid": Incident.serviceDetails.caseTypeData.contactDtls?.mailingadd,
        //     "lastname": Incident.serviceDetails.caseTypeData.contactDtls?.lastname,
        //     "alternateph": Incident.serviceDetails.caseTypeData.contactDtls?.phonenumber2,
        //     "emailalt1": Incident.serviceDetails.caseTypeData.contactDtls?.emailalt1,
        //     "firstname": Incident.serviceDetails.caseTypeData.contactDtls?.firstname,
        //     "phonenumber": Incident.serviceDetails.caseTypeData.contactDtls?.phonenumber1,
        //     "email": Incident.serviceDetails.caseTypeData.contactDtls?.emailaddress,
        //     "title": "1",
        //   },
        // }
      ]
      console.log(payload)

      payload.forEach((item: any) => {
        var entity_name = item.entityName


        if (entity_name) {
          const updatedPayload = {}; // Create a new object for updated payload

          for (const key in item.payLoad) {
            if (Object.prototype.hasOwnProperty.call(item.payLoad, key)) {
              const updatedKey = `${entity_name}.${key}`; // Append entity_name to key
              updatedPayload[updatedKey] = item.payLoad[key]; // Assign the updated key-value pair
            }
          }

          item.payLoad = updatedPayload;
        }
      })

      console.log(payload)
      this.customcreatepayload = payload
    }

    return this.objcontroller.onSaveObject(this.customcreatepayload)
    // return this.httpClient.post(this.backendUrl+'page/entity/customcreate', this.customcreatepayload, httpOptions);

  }

  fetchData(referenceId: any, propertyName: any) {
    console.log(referenceId)
    console.log(this.AlldataArray)
    let item = this.AlldataArray.find(item => item.refno == referenceId);
    if (!item) {
      console.log("no data found")
      return 0
    }
    else {
      console.log(item)
      // console.log(item[propertyName][0])
      if (item[propertyName][0] == undefined) {
        return 0
      }
      // console.log(item[0])
      // console.log(item[0][propertyName])
      return item[propertyName][0];
    }
  }

  myfavouritesarray:any=[]
  Allservicerequests:any=[]
commonfavcasetype:any=[]

  updatefavouritesarray()
  {
    console.log(this.Allservicerequests)
    console.log(this.myfavouritesarray)
    var arrayupdated:any=[]
    arrayupdated = this.Allservicerequests.filter(item1 =>
          this.myfavouritesarray.some(item2 => item1.casetypeid == item2.casetypeid && item1.department.id == item2.departmentid)
        );
        console.log(arrayupdated)
        this.commonfavcasetype=arrayupdated
        console.log(this.Allservicerequests)
        console.log(this.commonfavcasetype)
        // this.myfavouritesarray=arrayupdated
  }

  getMyFavourites() {
    // this.httpClient.get(environment.apiURL + 'getStarred').subscribe((data:any)=>{
    //   this.myfavouritesarray=data;
    //   console.log(data)
    //   this.updatefavouritesarray()
    // })
    return this.httpClient.get(environment.apiURL + 'getStarred')
  }

  getRecents(){
    return this.httpClient.get(environment.apiURL + 'getRecentServiceRequests')
  }

  getfilterbyseason(filtertype: any) {
    return this.httpClient.get(environment.apiURL + 'getSeasonByName/' + filtertype)

  }
  commonitems: any = []
  getiffaavourites(arrayItem: any) {
    // console.log(arrayItem)
    arrayItem.isfavourite = 'false'
    this.commonitems?.forEach((item: any) => {
      if (item.casetypeid == arrayItem.casetypeid && item.division.id == arrayItem.division.id && (((item.casesubtypeid != null && arrayItem.casesubtypeid != null) ? item.casesubtypeid == arrayItem.casesubtypeid : true))) {
        // elementfound=true
        arrayItem.isfavourite = 'true'
      }
    })
    // console.log(arrayItem)
  }

  unreadnotificationscount:any
  filterednotifications:any;
  allusernotifications:any

  updatereadmode(notifyid:any)
  {
    return this.httpClient.put(this.backendUrl+'updateMode?notifyid='+notifyid.id,{})
  }
  getusernotifications()
  {
    this.httpClient.get(this.backendUrl+'getUserNotifications').subscribe((data:any)=>
      {
        console.log(data)
        this.filterednotifications=data
        this.uservisiblenotifications=data
        // console.log(this.unreadnotificationscount)
      })

    // return this.httpClient.get(this.backendUrl + 'getUserNotifications')
  }

  savenotification(incidentid:any,refno:any,departmentid:any,casetype:any) {

    const formData: FormData = new FormData();
    formData.append('incidentid', incidentid);
    formData.append('refno', refno);
    formData.append('departmentid', departmentid);
    formData.append('casetype', casetype);
    // const formData = {
    //   "incidentid": +incidentid,
    //   "refno": refno,
    //   "departmentid": +departmentid,
    //   "casetype": +casetype
    // }
    this.httpClient.post(environment.apiURL + 'SaveNotification', formData).subscribe((data)=>
    {
      console.log(data)
    })

    
}

  uservisiblenotifications:any=[]
  toggleShowUnread(checked: boolean) {
    console.log(checked)
    if (checked) {
      // alert(checked)
      // Filter unread notifications
      this.filterednotifications = [...this.filterednotifications.filter(notification => !notification.readmode)];
      // console.log(this.filteredNotifications.length)
    } else {
      // Show all notifications
      this.filterednotifications = this.uservisiblenotifications;
    }
  }

  getuserallnotifications()
  {
    this.getNotificationsCountOfUnRead()
    this.httpClient.get(this.backendUrl+'getUserAllNotifications').subscribe((data:any)=>
      {
        // console.log(data)
        this.allusernotifications=data
        // this.unreadnotificationscount =data.filter(notification => !notification.readmode).length;
        // console.log(this.unreadnotificationscount)
        // alert(this.unreadnotificationscount)
        // setTimeout(() => {
        //   alert("after 100"+this.unreadnotificationscount)
        // }, 1000);
      })

    return this.httpClient.get(this.backendUrl+'getUserAllNotifications')

  }

  markallnotificationsread()
  {
    return this.httpClient.get(this.backendUrl+'readAll')
  }

  getNotificationsCountOfUnRead()
  {
    this.httpClient.get(this.backendUrl+'getNotificationsCountOfUnRead').subscribe((data:any)=>
      {
        // console.log(data)
        this.unreadnotificationscount=data
        // this.unreadnotificationscount =data.filter(notification => !notification.readmode).length;
        // console.log(this.unreadnotificationscount)
        // alert(this.unreadnotificationscount)
        // setTimeout(() => {
        //   alert("after 100"+this.unreadnotificationscount)
        // }, 1000);
      })
  }

  getnotificationscount()
  {
    return this.httpClient.get(this.backendUrl+'getNotificationsCount')

  }

}
